<ngx-ui-loader [loaderId]="'individualdashboard'"></ngx-ui-loader>
<div id="denyDashboardAccess" class="background">
  <div class="container-fluid">
    <div class="digitalNumber"
      style="justify-content: center;display: flex;align-items: center;z-index: 1000;margin-top: 1%;">
      <button class="button-19" (click)="open_individual(selectedTransformer.transformerid)" role="button"><span
          style="padding: 5px;">Graph</span></button><button class="button-19"
        (click)="openReport(selectedTransformer.transformerid)" role="button"><span
          style="padding: 5px;">Report</span></button><button class="button-19"
        (click)="alertReport(selectedTransformer.transformerid)" role="button"><span
          style="padding: 5px;">Alert</span></button>
      <button class="button-19" (click)="AIInsights(selectedTransformer)" role="button"><span style="padding: 5px;">AI
          Insights</span></button>
      <button *ngIf="isTwoMeter" class="button-19" (click)="openLiveGraph()" role="button"><span
          style="padding: 5px;">Live Data</span></button><button *ngIf="isTwoMeter" class="button-19"
        (click)="openLiveTable()" role="button"><span style="padding: 5px;">Live Table</span></button>
    </div>
    <div class="row firstRow digitalNumber" *ngIf="selectedTransformer">
      <div class="col-md-3" style="padding: 0px;color: aliceblue !important;">
        <div class="shadow-box" style="padding: 0px;background-color: #0a0d21d0;padding: 5px;">
          <ng-select class="transformer-name-select" style="background-color: #21295ed0 !important;padding: 0px;" [items]="transformerList"
            bindLabel="transformerDetail" placeholder="Transformer" [(ngModel)]="selectedTransformer"
            (change)="transformerSelection(selectedTransformer)" [clearable]="false">
          </ng-select>
          <div *ngIf="transformerData" style="margin-top:0% ;font-size:1.3vh;color:beige;width: 100%;">
            <div style="padding: 5px;"><b>Age:</b> {{selectedTransformer.age}} Year <span
                style="margin-left: 2%;"><b>Rating:</b> {{selectedTransformer.kvarating }} KVA</span><span
                style="margin-left: 2%;"><b>Rated Load:</b> {{selectedTransformer.ratedLoad | number:'1.0-0'}}</span>
            </div>
            <div><b>Last Data Recieved:</b> {{transformerData.latestDATE | date: 'MMM d, y h:mm a' }}</div>
            <div class="signal-wrapper"><b>Status:</b> <img style="margin-left: 2%;" [src]="statusImagePath"
                height="10%" width="10%"> <span [ngStyle]="{'opacity': networkFlag ? '1' : '0.2'}"
                class="signal-wrapper" style="margin-left: 1%;">Network: <span class="signal-container">
                  <div [matTooltip]="NetworkValue" matTooltipPosition="above" matTooltipClass="auto-adjust-tooltip"
                    *ngFor="let bar of bars; let i = index" [ngClass]="{'active': i < signalStrength}"
                    class="signal-bar"></div>
                </span>
              </span>
              <span style="margin-left: 1%;"><b>Battery:</b><img [src]="batteryStatusImgUrl" height="30%"
                  width="30%"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3 digitalNumber" *ngIf="parameterConfig">
        <div
          [ngStyle]="{'opacity': parameterConfig.windingtemperature == 1 || parameterConfig.windingtemperaturebycal == 1 ? '1' : '0.4'}"
          class="graph graph-right" style="flex: 1; height: 100%; max-width: 48%; box-sizing: border-box;">
          <div id="wrapper" *ngIf="transformerData">
            <div id="termometer">
              <div id="temperature" [style.height]="temperatureHeight"
                [attr.data-value]="transformerData.Winding_Temperature + '°C'"></div>
              <div id="graduations"></div>
            </div>
            <p id="info">Winding<br> Temperature</p>
          </div>
        </div>
      </div>
      <div class="col-md-3 digitalNumber" *ngIf="parameterConfig">
        <div [ngStyle]="{'opacity': parameterConfig.oiltemperature == 1 ? '1' : '0.4'}" class="graph graph-left"
          style="flex: 1; height: 100%; max-width: 48%; box-sizing: border-box;">
          <div id="wrapper" *ngIf="transformerData">
            <div id="termometer">
              <div id="temperature" [style.height]="temperatureHeightoil"
                [attr.data-value]="transformerData.Oil_Temperature+ '°C'"></div>
              <div id="graduations"></div>
            </div>
            <p id="info">Oil <br> Temperature</p>
          </div>
        </div>
      </div>
      <div class="col-md-3" style="padding: 0px;">
        <div *ngIf="parameterConfig" class="shadow-box"
          style="color:beige;padding: 0px;background-color: #0a0d21d0;padding: 5px;">
          <div class="param-header">
            <span></span>
            <span class="col-r">R</span>
            <span class="col-y">Y</span>
            <span class="col-b">B</span>
          </div>

          <div [ngStyle]="{'opacity': parameterConfig.lugtempr == 1 ? '1' : '0.4'}" class="param-row">
            <b>Lug Temp (°C):</b>
            <span class="col-r">{{Lug_Temp_R | number:'1.2-2'}}</span>
            <span class="col-y">{{Lug_Temp_Y | number:'1.2-2'}}</span>
            <span class="col-b">{{Lug_Temp_B | number:'1.2-2'}}</span>
          </div>

          <div [ngStyle]="{'opacity': parameterConfig.irThd == 1 ? '1' : '0.4'}" class="param-row">
            <b>Current THD (%):</b>
            <span class="col-r" *ngIf="parameterConfig.irThd == 1">{{jsonReadings.IR_THD | number:'1.2-2'}}</span>
            <span class="col-y" *ngIf="parameterConfig.iyThd == 1">{{jsonReadings.IY_THD | number:'1.2-2'}}</span>
            <span class="col-b" *ngIf="parameterConfig.ibThd == 1">{{jsonReadings.IB_THD | number:'1.2-2'}}</span>
          </div>

          <div [ngStyle]="{'opacity': parameterConfig.vrThd == 1 ? '1' : '0.4'}" class="param-row">
            <b>Voltage THD (%):</b>
            <span class="col-r" *ngIf="parameterConfig.vrThd == 1">{{jsonReadings.VR_THD | number:'1.2-2'}}</span>
            <span class="col-y" *ngIf="parameterConfig.vyThd == 1">{{jsonReadings.VY_THD | number:'1.2-2'}}</span>
            <span class="col-b" *ngIf="parameterConfig.vbThd == 1">{{jsonReadings.VB_THD | number:'1.2-2'}}</span>
          </div>

          <div [ngStyle]="{'opacity': parameterConfig.rPowerFactor == 1 ? '1' : '0.4'}" class="param-row">
            <b>Power Factor:</b>
            <span class="col-r" *ngIf="parameterConfig.rPowerFactor == 1">{{jsonReadings.R_Power_Factor |
              number:'1.2-2'}}</span>
            <span class="col-y" *ngIf="parameterConfig.yPowerFactor == 1">{{jsonReadings.Y_Power_Factor |
              number:'1.2-2'}}</span>
            <span class="col-b" *ngIf="parameterConfig.bPowerFactor == 1">{{jsonReadings.B_Power_Factor |
              number:'1.2-2'}}</span>
          </div>

          <div [ngStyle]="{'opacity': parameterConfig.rActivePower == 1 ? '1' : '0.4'}" class="param-row">
            <b>Active Power</b>
            <span class="col-r" *ngIf="parameterConfig.yActivePower == 1">{{jsonReadings.R_Active_Power |
              number:'1.2-2'}}</span>
            <span class="col-y" *ngIf="parameterConfig.yActivePower == 1">{{jsonReadings.Y_Active_Power |
              number:'1.2-2'}}</span>
            <span class="col-b" *ngIf="parameterConfig.bActivePower == 1">{{jsonReadings.B_Active_Power |
              number:'1.2-2'}}</span>
          </div>

          <div
            [ngStyle]="{'opacity': parameterConfig.Relative_Pressure == 1 || parameterConfig.tapposition == 1 ? '1' : '0.4'}"
            class="param-row">
            <b *ngIf="parameterConfig.Relative_Pressure == 1">Relative Pressure</b>
            <span *ngIf="parameterConfig.Relative_Pressure == 1" class="col-span-value"
              style="color: rgb(0, 255, 195);">
              {{weatherData?.relative_pressure}}
            </span>

            <b *ngIf="parameterConfig.tapposition == 1">Tap Position</b>
            <span *ngIf="parameterConfig.tapposition == 1" class="col-span-value" style="color: rgb(0, 255, 195);">
              {{jsonReadings.Parameter1}}
            </span>
          </div>

          <div *ngIf="transformerData" class="digitalNumber ambient-row">
            <b [ngStyle]="{'opacity': parameterConfig.ambienttemperature == 1 ? '1' : '0.2'}">
              Ambient Temp<br><span style="color: coral;">{{transformerData.Ambient_Temperature |
                number:'1.0-0'}}°C</span>
            </b>
            <b [ngStyle]="{'opacity': parameterConfig.humidity == 1 ? '1' : '0.2'}">
              Humidity<br><span style="color: coral;">{{transformerData.Humidity | number:'1.0-0'}}%</span>
            </b>
            <b [ngStyle]="{'opacity': parameterConfig.frequency == 1 ? '1' : '0.2'}">
              Frequency<br><span style="color: coral;">{{jsonReadings.Frequency | number:'1.0-0'}}</span>
            </b>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="box small digitalNumber">
        <div *ngIf="parameterConfig && jsonReadings" style="font-size: 2vh;text-align: center;">
          <div [ngStyle]="{'opacity': parameterConfig.brVoltage == 1 ? '1' : '0.4'}">
            <span style="color: white;font-size: 1.6vh;">Line Voltage</span><br><br>
            <div>
              <span
                style="background-color: rgba(135, 0, 0, 0.76);padding: 10px;box-shadow: 0px 0px 2px 2px rgba(255, 0, 0, 0.719);color: white;width: auto;">{{jsonReadings.RY_Voltage
                | number:'1.0-0'}}</span>
              <span
                style="background-color: rgb(114, 145, 0);padding: 10px;margin-left: 10px;margin-right: 10px;box-shadow: 0px 0px 2px 2px rgb(203, 255, 16);color: white;">{{jsonReadings.YB_Voltage|number:'1.0-0'}}</span>
              <span
                style="background-color: rgba(8, 0, 121, 0.838);padding: 10px;box-shadow: 0px 0px 2px 2px rgb(25, 8, 255);color: white;">{{jsonReadings.BR_Voltage|number:'1.0-0'}}</span>
            </div>
          </div><br>
          <div>
            <span style="color: white;">Current</span><br><br>
            <div [ngStyle]="{'opacity': parameterConfig.l1 == 1 ? '1' : '0.4'}">
              <span
                style="background-color: rgba(135, 0, 0, 0.76);padding: 10px;box-shadow: 0px 0px 2px 2px rgba(255, 0, 0, 0.719);color: white;">{{jsonReadings.L1|number:'1.0-0'}}</span>
              <span
                style="background-color: rgb(114, 145, 0);padding: 10px;margin-left: 10px;margin-right: 10px;box-shadow: 0px 0px 2px 2px rgb(203, 255, 16);color: white;">{{jsonReadings.L2
                | number:'1.0-0'}}</span>
              <span
                style="background-color: rgba(8, 0, 121, 0.838);padding: 10px;box-shadow: 0px 0px 2px 2px rgb(25, 8, 255);color: white;">{{jsonReadings.L3
                | number:'1.0-0'}}</span>
            </div>
          </div>
        </div>
        <div id="isOilLevelOn">
          <div style=" height:27vh;min-height:27vh;z-index: 3000 " id="oilLevel"></div>
        </div>
      </div>
      <div class="box middle" style="z-index: 300;">
        <model-viewer src="../../../assets/glb3d/test25.glb" alt="3D Power Transformer" auto-rotate ar camera-controls
          shadow-intensity="5" exposure="0.6" tone-mapping="aces" max-texture-size="8192" contrast="3" saturation="5"
          highlight-color="#FFFFFF" camera-orbit="30deg 50deg 35deg" lighting="scene" bloom="true" bloom-intensity="2"
          depth-of-field="true" light-intensity="100" light-color="#FFFFFF" reflectivity="5" specular-intensity="2"
          interaction-prompt="auto">
        </model-viewer>
      </div>
      <div class="box small">

        <div id="isLoadOn">
          <div style=" height:24vh;min-height:24vh;z-index: 3000" id="load"></div>
        </div>
        <div id="isoltcOilLevelOn">
          <div style=" height:24vh;min-height:24vh; " id="TapoilLevel"></div>
        </div><!--
                <div *ngIf="parameterConfig">
                <div [ngStyle]="{'opacity': parameterConfig.oiltemperature == 1 && parameterConfig.ambienttemperature == 1 ? '1' : '0.4'}" class="graph graph-left" style="flex: 1; height: 100%; box-sizing: border-box;padding: 40px;">
                    <div id="wrapper" class="digitalNumber" *ngIf="transformerData">
                        <div id="termometer">
                            <div id="temperature" [style.height]="temperatureHeightHotspot" [attr.data-value]="hotSpotCalculationValue+ '°C'"></div>
                            <div id="graduations"></div>
                        </div>
                        <p id="info" >Hotspot <br> Calculation</p>
                    </div>
                </div>
                </div> -->
      </div>
    </div>
    <div class="row thirdRow">
      <div *ngIf="selectedTransformer" class="col-md-2 digitalNumber" style="padding: 0px;">
        <div class="shadow-box"
          style="color: white;padding: 0px;background-color: #210a0a;padding: 5px;min-height: 25vh;">
          <b style="display: flex;align-items: center;justify-content: center;color: rgba(198, 37, 37, 0.893);">Active
            Alerts</b>
          <div *ngIf="alertsData">
            <div style="font-size: 1.8vh;margin-left: 10%;color: rgba(255, 68, 68, 0.893);" class="blink"
              *ngFor="let alert of alertsData">{{alert.parametername}}: {{alert.gparametervalue}}</div>
          </div>
        </div>
      </div>
      <div style="margin-left: -5%;margin-top: -3%;" class="col-md-3" style="height:27vh;min-height:27vh;z-index: 4000;"
        id="healthIndex"></div>
      <div class="col-md-3"></div>
      <div class="col-md-4">
        <div class="containers">
          <div class="secondscreens" *ngIf="showInfo === 'first'">
            <div class="screen">
              <div class="rowl">
                <div class="lcdisplays">
                  <span id="kWh" [class.blink]="blinkState" #kWhElement>{{kWh}} </span>
                </div>
                <span class="unit">kWh</span>
              </div>
            </div>
            <div class="screen">
              <div class="rowl">
                <div class="lcdisplays">
                  <span id="kWh">{{kVAh}}</span>
                </div>
                <span class="unit">Kvah</span>
              </div>
            </div>

            <div class="screen">
              <div class="rowl">
                <div class="lcdisplays">
                  <span id="kWh">{{activePower}}</span>
                </div>
                <span class="unit">KW</span>
              </div>
            </div>
            <div class="screen">
              <div class="rowl">
                <div class="lcdisplays">
                  <span id="kWh">{{avgPF}}</span>
                </div>
                <span class="unit">Avg_PF</span>
              </div>
            </div>
          </div>
          <div class="secondscreens" *ngIf="showInfo === 'second'"
            [ngStyle]="voltageparameter ? {} : {'opacity': '0.5'}">
            <h6 style=" font-family: 'DigitalFont';margin:0px;font-weight: bold; font-size: 2vh;">
              Voltage
            </h6>
            <div class="row">
              <div class="col-md-6">
                <div>
                  <a style=" font-family: 'DigitalFont';
                              font-weight: bold;
                              font-size: 21px;
                              margin-right: 116px;">R</a>
                </div>
                <div>
                  <a style=" font-family: 'DigitalFont';
                              font-weight: bold;
                              font-size: 21px;
                              margin-right: 116px;">Y</a>
                </div>
                <div>
                  <a style=" font-family: 'DigitalFont';
                               font-weight: bold;
                               font-size: 21px;
                               margin-right: 116px;">B</a>
                </div>
              </div>
              <div class="col-md-6">
                <a style=" font-family: 'DigitalFont';
                            font-weight: bold;
                            font-size: 21px;
                           "> {{voltage_l1}} </a> <br>
                <a style=" font-family: 'DigitalFont';
                            font-weight: bold;
                            font-size: 21px;
                           "> {{voltage_l2}} </a> <br>
                <a style=" font-family: 'DigitalFont';
                             font-weight: bold;
                             font-size: 21px;
                            "> {{voltage_l3}} </a>
              </div>
            </div>
          </div>
          <div class="secondscreens" *ngIf="showInfo === 'third'"
            [ngStyle]="voltageparameter ? {} : {'opacity': '0.5'}">
            <h6 style="font-family: 'DigitalFont'; margin: 0px; font-weight: bold; font-size: 2vh;">
              &nbsp; &nbsp; Current &nbsp; &nbsp;
            </h6>
            <div class="row">
              <div class="col-md-6">
                <div>
                  <a style=" font-family: 'DigitalFont';
                              font-weight: bold;
                              font-size: 21px;
                              margin-right: 116px;"> R </a>
                </div>
                <div>
                  <a style=" font-family: 'DigitalFont';
                              font-weight: bold;
                              font-size: 21px;
                              margin-right: 116px;"> Y </a>
                </div>
                <div>
                  <a style=" font-family: 'DigitalFont';
                               font-weight: bold;
                               font-size: 21px;
                               margin-right: 116px;"> B </a>
                </div>
              </div>
              <div class="col-md-6">
                <a style=" font-family: 'DigitalFont';
                            font-weight: bold;
                            font-size: 21px;
                           ">{{current_l1}} </a> <br>
                <a style=" font-family: 'DigitalFont';
                            font-weight: bold;
                            font-size: 21px;
                           "> {{current_l2}} </a> <br>
                <a style=" font-family: 'DigitalFont';
                             font-weight: bold;
                             font-size: 21px;
                            "> {{current_l3}} </a>
              </div>
            </div>
          </div>
          <div class="secondscreens" *ngIf="showInfo === 'fourth'">
            <h6 style=" font-family: 'DigitalFont';margin:0px;font-weight: bold; font-size: 24px;">
              Avg. PF
            </h6>
            <div class="row">
              <div>
                <a style=" font-family: 'DigitalFont';
                            font-weight: bold;
                            font-size: 27px;
                           text-align: center;
                           "> 0.76 </a> <br>
              </div>
            </div>
          </div>
          <div class="row" style="margin-top: 11px; margin-bottom: 7px;">
            <div *ngIf="showInfo === 'waitthird'">
              <button style="background-color: #14721F; height: 24px; " (click)="lastfive()">
                <i class="fas fa-chevron-left" style="color: black;"></i>
              </button>
            </div>
            <div *ngIf="showInfo === 'waitsecond'">
              <button style="background-color: #14721F; height: 24px; " (click)="lastfive()">
                <i class="fas fa-chevron-left" style="color: black;"></i>
              </button>
            </div>
            <button style="background-color: #14721F; height: 24px;" (click)="showPrev()">
              <i class="fas fa-angle-up" style="color: black;"></i>
            </button>
            <button style="background-color: #14721F; height: 24px; margin-left: 30px;" (click)="showNext()">
              <i class="fas fa-angle-down" style="color: black;"></i>
            </button>
            <button style="background-color: #14721F; height: 24px; margin-left: 30px;" (click)="resetkwhreset()">
              <i class="fas fa-sync-alt" style="color: black;"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <button class="fab digitalNumber" (click)="toggleChatBox()"><img
        src="https://cdn.dribbble.com/users/1446559/screenshots/5453050/97e3bc07ac5ca76150df36be8e142336.gif"></button>
    <div *ngIf="isChatOpen" class="chat-box-container">
      <div style="background-color: #030724;border: solid 1px #444e8b;width:100%"><img
          src="../../../assets/images/BOLAAI.jpg" height="100%" width="8%"><span
          style="color: white;font-size: 1.5vh;margin-left: 1%;">BOLA_AI_1.0</span></div>
      <div #chatWindow class="chat-window digitalNumber">
        <div class="messages" *ngFor="let message of messages">
          <div [ngClass]="{ 'user-message': message.sender === 'user', 'ai-message': message.sender === 'ai' }">
            <p [innerHTML]="message.message" style="padding: 2px;"></p>
          </div>
        </div>
      </div>

      <div class="input-container">
        <input [(ngModel)]="userMessage" [disabled]="isTyping" (keyup.enter)="sendMessage()"
          placeholder="Message BOLA AI..." />
        <button (click)="sendMessage()" class="button-19" role="button" [disabled]="isTyping">Send</button>
      </div>
    </div>
  </div>
</div>